import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: "AIzaSyAy7i1RqQdZguQTaST527tl-Q_VLVZns5I",
  authDomain: "maruhill-7c47d.firebaseapp.com",
  projectId: "maruhill-7c47d",
  storageBucket: "maruhill-7c47d.firebasestorage.app",
  messagingSenderId: "523801421452",
  appId: "1:523801421452:web:e33f58c2185c0755487da9",
  measurementId: "G-M45K6FR2YS"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
const analytics = getAnalytics(app)

export { db, analytics }
export default app
